<template>
  <div class="page">
    <Quicksearch v-bind:searching.sync="searching" v-bind:callback="callback"/>
    <div class="container container-nopaddinghorizontal container-afterheader container-includestaticfooter">      
        <transition name="container-overlay">
            <div class="container-overlay" v-if="searching"></div>      
        </transition>
        <div class="container container-small page-content" v-if="data">   
            <h1  v-html="data.Data.Titel.Parsed[$root.language]"></h1>
            <div v-html="data.Data.Text.Parsed[$root.language]"></div>
            <div class="page-logoblock" v-if="data.Data.Bild && data.Data.Bild.Content && data.Data.Bild.Content.length > 0">
              <a v-for="(b, bid) in data.Data.Bild.Content" :key="`logo-${bid}`" :href="b.Captions" target="_blank">
                <img :src="b.Files.Original"/>
              </a>
            </div>
        </div>
    </div>
    <StaticFooter/>
  </div>
</template>

<style lang="scss">
  @import "../main";
  .page {
      &-content {
          & > h1 {
              margin-top: $base-size * 2;
          }
          & > div {
              max-width: 660px;
              hyphens: auto;
              text-align: justify;
          }
      }
      &-logoblock {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid;
        margin-top: 2rem;
        padding-top: 2rem;
        a {
          flex-basis: 25%;
          img {
            width: 100%;
            max-height: 5rem;
          }
        }
      }
  }

</style>

<script>

import Quicksearch from '@/components/Quicksearch.vue'
import StaticFooter from '@/components/StaticFooter.vue'


export default {
  name: 'page',
  components: {
      Quicksearch,
      StaticFooter
  },
  data() {
    return {
        data: null,
        searching: false,
    }
  },
  mounted() {
    this.fetchData()          
  },
  watch: {
    '$route' () {
        this.fetchData(); 
    }
  },
  methods: {
    async fetchData() {
        this.data = await this.$store.dispatch('load', {mode: `/contribution/${this.$route.params.id}`});
    },
    callback() {
        this.$router.push({ name: 'searchresults' })
    },
  }
}
</script>
